import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function isValidDate(dateString: string): boolean {
  try {
    const [day, month, year] = dateString.split('/');
    if (!day || !month || !year) return false;

    const dayNum = Number(day);
    const monthNum = Number(month);
    const yearNum = Number(year);

    if (monthNum < 1 || monthNum > 12) return false;
    if (dayNum < 1 || dayNum > 31) return false;
    if (yearNum < 1900 || yearNum > 2100) return false;

    if (monthNum === 2) {
      const isLeapYear = (yearNum % 4 === 0 && yearNum % 100 !== 0) || yearNum % 400 === 0;
      if (dayNum > (isLeapYear ? 29 : 28)) return false;
    }

    if ([4, 6, 9, 11].includes(monthNum) && dayNum > 30) return false;

    return true;
  } catch {
    return false;
  }
}

/**
 * Formata DD/MM/YYYY para exibição sem problema de timezone (-1 dia).
 * Usa new Date(year, month-1, day) para evitar que ISO seja interpretado como UTC.
 */
export function formatDateBR(dateStr: string, formatStr: string): string {
  if (!dateStr || !isValidDate(dateStr)) return 'Data inválida';
  try {
    const [day, month, year] = dateStr.split('/');
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return format(date, formatStr, { locale: ptBR });
  } catch {
    return 'Data inválida';
  }
}
